import { AccountInterface } from '@interface/account/account.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';

export const BaseStoreStructure: Omit<BaseStoreInterface<AccountInterface[]>, 'data'> = {
  isLoading: false,
  isLoaded: false,
  error: null,
  meta: {},
};
